import React, { FC } from "react";
import { LinearProgress, Preview } from "@evergis/ui";

import { NoLiveSnapshot } from "./components/NoLiveSnapshot";
import { SmallPreview } from "./components/SmallPreview";
import { AttributeGalleryContainer, LinearProgressContainer } from "./styled";
import { AttributeLabel } from "../../styled";
import { ExpandableTitle } from "../ExpandableTitle/ExpandableTitle";
import { isVisibleContainer } from "../../utils/isVisibleContainer";
import { useCameraAttribute } from "./hooks/useCameraAttribute";
import { useWidgetContext } from "../../../Dashboard/hooks/useWidgetContext";
import { CameraAttributeProps } from "./types";

export const CameraAttribute: FC<CameraAttributeProps> = ({ field, value, elementConfig, type, renderElement }) => {
  const { expandedContainers } = useWidgetContext(type);

  const { id, options } = elementConfig || {};
  const { expandable, expanded } = options || {};
  const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

  const [
    { currentIndex, currentPage, totalCount, galleryImages, isLoadingSnapshot, isLoadingTimeline, isOpenGallery },
    { setCurrentIndex, toggleGallery, onNextPage },
  ] = useCameraAttribute(value);

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
      {isVisible && (
        <>
          {!!field && <AttributeLabel>{field}</AttributeLabel>}
          <AttributeGalleryContainer>
            {isLoadingSnapshot ? (
              <LinearProgressContainer>
                <LinearProgress />
              </LinearProgressContainer>
            ) : !galleryImages?.length && !isLoadingTimeline ? (
              <NoLiveSnapshot />
            ) : (
              <SmallPreview
                images={galleryImages}
                totalCount={totalCount}
                currentIndex={currentIndex}
                isLoading={isLoadingTimeline}
                setCurrentIndex={setCurrentIndex}
                onClick={toggleGallery}
                onNextPage={onNextPage}
              />
            )}
          </AttributeGalleryContainer>
          {isOpenGallery && (
            <Preview
              images={galleryImages}
              currentIndex={currentIndex}
              currentPage={currentPage}
              totalCount={totalCount}
              isOpen={isOpenGallery}
              isLoading={isLoadingTimeline}
              hasSidebar
              onClose={toggleGallery}
              setCurrentIndex={setCurrentIndex}
              onNextPage={onNextPage}
            />
          )}
        </>
      )}
    </>
  );
};
